__turbopack_context__.v({
  "cornerLeft": "LWFKgW_cornerLeft",
  "cornerRight": "LWFKgW_cornerRight",
  "divider": "LWFKgW_divider",
  "line": "LWFKgW_line",
  "withCorners": "LWFKgW_withCorners",
});
